export default __webpack_public_path__ + "static/media/header-img.24c2d5ed.webp";